import React from "react";
import { useWorldContract } from "../../../mud/useWorldContract";
import { Severity } from "@eveworld/types";
import setBringOffline from "../../systemCalls/handleBringOffline";
import { EveButton } from "@eveworld/ui-components";
import { useNotification } from "@eveworld/contexts";

interface ButtonProps {
  AssemblyId: string;
}

const BringOfflineButton: React.FC<ButtonProps> = ({ AssemblyId }) => {
  const { worldContract } = useWorldContract();
  const { notify } = useNotification();

  const handleBringOffline = async (SmartObjectId: string) => {
    const txHash = await setBringOffline({
      worldContract,
      smartObjectId: SmartObjectId,
    });
    if (txHash) {
      notify({ type: Severity.Success, txHash });
    } else {
      notify({
        type: Severity.Error,
        message: "Transaction failed to execute",
      });
    }
  };

  return (
    <EveButton
      typeClass="primary"
      onClick={() => handleBringOffline(AssemblyId)}
    >
      Take Offline
    </EveButton>
  );
};

export default React.memo(BringOfflineButton);
